"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainUI = exports.AppScreen = void 0;
var React = __importStar(require("react"));
var Landing_1 = require("./screens/Landing");
var GameScreen_1 = require("./screens/GameScreen");
var LevelComplete_1 = require("./screens/LevelComplete");
var ScreenChangeEvent_1 = require("./events/ScreenChangeEvent");
var GameComplete_1 = require("./screens/GameComplete");
var MenuScreen_1 = require("./screens/MenuScreen");
var AppScreen;
(function (AppScreen) {
    AppScreen[AppScreen["Loading"] = 0] = "Loading";
    AppScreen[AppScreen["Menu"] = 1] = "Menu";
    AppScreen[AppScreen["Game"] = 2] = "Game";
    AppScreen[AppScreen["LevelComplete"] = 3] = "LevelComplete";
    AppScreen[AppScreen["GameComplete"] = 4] = "GameComplete";
})(AppScreen = exports.AppScreen || (exports.AppScreen = {}));
var MainUI = /** @class */ (function (_super) {
    __extends(MainUI, _super);
    function MainUI(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentScreen: AppScreen.Loading
        };
        return _this;
    }
    MainUI.prototype.componentDidMount = function () {
        this.props.app.addEventListener(ScreenChangeEvent_1.ScreenChangedEvent.SCREEN_CHANGED, this.onScreenChanged, this);
    };
    MainUI.prototype.onScreenChanged = function (e) {
        this.setState({
            currentScreen: e.screen
        });
    };
    MainUI.prototype.render = function () {
        // const level = this.props.app.currentLevel();
        var _this = this;
        return (React.createElement("main", null,
            React.createElement("div", { className: "screen "
                    + AppScreen[this.state.currentScreen].toLowerCase()
                    + "-screen" }, (function () {
                switch (_this.state.currentScreen) {
                    case AppScreen.Loading:
                        return React.createElement(Landing_1.Loading, { app: _this.props.app });
                    case AppScreen.Menu:
                        return React.createElement(MenuScreen_1.MenuScreen, { app: _this.props.app });
                    case AppScreen.Game:
                        return React.createElement(GameScreen_1.GameScreen, { app: _this.props.app });
                    case AppScreen.LevelComplete:
                        return React.createElement(LevelComplete_1.LevelComplete, { app: _this.props.app });
                    case AppScreen.GameComplete:
                        return React.createElement(GameComplete_1.GameComplete, { app: _this.props.app });
                    default:
                        console.error("MainUIUI ** Screen not found");
                        return;
                }
            })())));
    };
    MainUI.prototype.componentWillUnmount = function () {
        this.props.app.removeEventListener(ScreenChangeEvent_1.ScreenChangedEvent.SCREEN_CHANGED, this.onScreenChanged);
    };
    return MainUI;
}(React.Component));
exports.MainUI = MainUI;
